import script from "./Editar.vue?vue&type=script&lang=ts"
export * from "./Editar.vue?vue&type=script&lang=ts"

export default script